import CardLineIcon from '../shared/Icons/CardLineIcon';
import ContactlessPaymentIcon from '../shared/Icons/ContactlessPaymentIcon';
import CrossIcon from '../shared/Icons/CrossIcon';
import DepositFilledIcon from '../shared/Icons/DepositFilledIcon';
import PinIcon from '../shared/Icons/PinIcon';
import PosCardIcon from '../shared/Icons/PosCardIcon';
import StoreFilledIcon from '../shared/Icons/StoreFilledIcon';
import TransferDebitFilledIcon from '../shared/Icons/TransferDebitFilledIcon';
import WalletIcon from '../shared/Icons/WalletIcon';
import CashbackIcon from '../shared/Icons/CashbackIcon';
import CheckShieldIcon from '../shared/Icons/CheckShieldIcon';
import CreditCreditFilledIcon from '../shared/Icons/CreditCreditFilledIcon';
import ExternalLinkIcon from '../shared/Icons/ExternalLinkIcon';
import FireIcon from '../shared/Icons/FireIcon';
import InstallmentsFilled from '../shared/Icons/InstallmentsFilled';

export const SendMoneyBottomSheetType = {
  SEND_MONEY: 'P2P',
  SEND_MONEY_TO_COMPANY: 'SEND_MONEY_TO_COMPANY',
};

export const SendMoneyBottomProvider = (
  t,
  organization,
  sendMoneyToCompanyEnabled,
) => {
  let items = [
    {
      type: SendMoneyBottomSheetType.SEND_MONEY,
      icon: <InstallmentsFilled />,
      title: t('Send money'),
    },
  ];

  if (sendMoneyToCompanyEnabled) {
    items.push({
      type: SendMoneyBottomSheetType.SEND_MONEY_TO_COMPANY,
      icon: <ExternalLinkIcon />,
      title: t('Send money to Company'),
    });
  }

  return {
    title: t('Send money'),
    titleStyle: 'bottom-sheet-title',
    items: items,
    alertStyle: 'bottom-sheet-items',
    buttonTitle: t('Confirm'),
  };
};
